import { ForbiddenError } from "./ForbiddenError.js";
class RefExpiredError extends ForbiddenError {}
export { RefExpiredError };
